export interface Entity {
    code: string,
    name: string,
    bgColor: string
}

export interface EntitySubtype {
    key: string
    icon: string
}

export enum EntityEnum {
    GENERAL = 'GENERAL',
    PATIENT = 'PATIENT',
    REQUEST = 'REQUEST',
    CASE = 'CASE',
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION'
}

// TODO refactorizar las coreentities y meter aquí los posibles valores (COREENTITY_VALUES)
